import {
  createEntityAdapter,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from 'src/store/index';

export type State = {
  loading: boolean;
  search: {
    data?: Model.FAQ[];
    params?: SearchParams.FAQ;
  };
};

export const adapter = createEntityAdapter<Model.FAQ>({
  selectId: (model) => model.id,
});

const { reducer, actions } = createSlice({
  name: 'faq',
  initialState: adapter.getInitialState<State>({
    loading: false,
    search: {},
  }),
  reducers: {
    updateEntities(state, action: PayloadAction<Model.FAQ[]>) {
      adapter.upsertMany(state, action);
    },
    updateEntity(state, action: PayloadAction<Model.FAQ>) {
      adapter.upsertOne(state, action);
    },
    updateLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    updateSearch(
      state,
      action: PayloadAction<{ data: Model.FAQ[]; params: SearchParams.FAQ }>,
    ) {
      const { params, data = [] } = action.payload;
      state.search.data = data;
      state.search.params = params;
    },
    removeEntity(state, action: PayloadAction<string>) {
      adapter.removeOne(state, action.payload);
    },
    updateTags(
      state,
      action: PayloadAction<{ id: string; faq_tags: Model.FAQ_TAG[] }>,
    ) {
      const { id, faq_tags } = action.payload;

      adapter.updateOne(state, { id, changes: { faq_tags } });
    },
  },
});

export const selector = adapter.getSelectors(
  (state: RootState) => state.model.faq,
);

export const selectFAQWithSearch = createSelector(
  selector.selectAll,
  selector.selectEntities,
  (state: RootState) => state.model.faq.search,
  (faqs, faqEntities, { params, data = [] }) => {
    const query: SearchParams.FAQ = {
      faq_category_id: params?.faq_category_id,
      q: params?.q,
      tags: params?.tags,
    };

    if (query?.faq_category_id || query?.q || query?.tags) {
      return data.map((d) => faqEntities[d.id]!);
    }

    return faqs;
  },
);

export { reducer };
export default actions;
